






































import { Vue, Component, Prop } from 'vue-property-decorator';
import { ExportFile } from '@/data-service';
import ExportCard from '@/components/ExportCard.vue';
import { EXPORT_FILES } from '@/store';
// eslint-disable-next-line
import Lottie from 'vue-lottie';
import * as loaderColor from '@/assets/loader-color.json';

@Component({
  components: {
    ExportCard,
    lottie: Lottie
  }
})
export default class ExportList extends Vue {
  @Prop({ required: true }) loading!: boolean;
  @Prop({ required: true }) apiError!: boolean;

  loadingAnimationOptions = {
    animationData: loaderColor.default
  };

  get exportFiles() {
    return this.$store.getters[EXPORT_FILES];
  }
}
